import Link from 'next/link';
import React from 'react';

const WorkstationsCustomQuote = ({ custom_quote, model_page }) => {
  return (
    <>
      <div className="quote-wrapper">
        <span className="quote-empty-block"></span>
        <div className="quote-content">
          <h1 className="quote-title">{custom_quote.title}</h1>
          <span className="quote-description">{custom_quote.description}</span>
          <Link href="/pages/corporate">
            <a>
              <div className="quote-button">
                <span className="quote-button-text">Enquire now</span>
              </div>
            </a>
          </Link>
        </div>
      </div>
      <style jsx>{`
        .quote-wrapper {
          display: flex;
          justify-content: center;
          align-items: ${model_page ? 'center' : 'flex-end'};
          margin-top: ${model_page ? '-25px' : '25px'};
        }
        .quote-content {
          width: 100%;
          padding: 15px;
          display: flex;
          flex-direction: column;
          align-items: ${model_page ? 'center' : 'start'};
          gap: 20px;
          flex: ${model_page ? '1' : '3'};
          max-width: ${model_page ? '1038px' : ''};
          margin-bottom: ${model_page ? '30px' : ''};
          border-radius: 4px;
          background-color: #121212;
        }
        .quote-empty-block {
          width: 100%;
          display: ${model_page ? 'none' : 'flex'};
          flex: 1;
        }
        .quote-title {
          font-family: Eurostile-Bold;
          font-size: 32px;
          color: white;
          margin: 0;
        }
        .quote-description {
          display: block;
          font-size: 20px;
          max-width: ${model_page ? '773px' : ''};
          text-align: ${model_page ? 'center' : ''};
          color: white;
        }
        .quote-button {
          width: ${model_page ? '185px' : '141px'};
          height: ${model_page ? '46px' : '41px'};
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          font-family: Eurostile-Bold;
          font-size: 20px;
          color: white;
          background-color: #a41c1c;
          cursor: pointer;
        }
        @media (max-width: 991px) {
          .quote-wrapper {
            margin-top: ${model_page ? '-40px' : '25px'};
          }
          .quote-content {
            margin-top: 0;
          }
          .quote-empty-block {
            display: none;
          }
          .quote-title {
            text-align: ${model_page ? 'center' : ''};
          }
        }
        @media (max-width: 767px) {
          .quote-wrapper {
            margin-top: ${model_page ? '-25px' : '20px'};
          }
          .quote-content {
            margin-top: ${model_page ? '30px' : '0'};
          }
        }
        @media (max-width: 595px) {
          .quote-content {
            margin-top: 0;
          }
        }
        @media (max-width: 430px) {
          .quote-content {
            align-items: center;
            margin-top: 10px;
          }
          .quote-title {
            text-align: center;
          }
          .quote-description {
            text-align: center;
          }
        }
      `}</style>
    </>
  );
};

export default WorkstationsCustomQuote;
